import { HttpErrorResponse } from "@angular/common/http";
import { Component, NgZone, OnInit, ViewChild } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { startWith } from "rxjs/operators";
import { LaudoInput } from "src/app/models/laudo-input";
import { EnderecoService } from "src/app/services/http/endereco.service";
import { HgService } from "src/app/services/http/hg.service";
import { LaudoUnionService } from "src/app/services/http/laudo-union.service";
import { ModalMsgService } from "src/app/services/modal-msg.service";
import { UserConfigsUtils } from "src/app/utils/UserConfigsUtils";
import { generateIdempotencyKey } from "src/app/utils/idempotency-key.util";
import { ImageEditorModalComponent } from "../components/image-editor/image-editor-modal/image-editor-modal.component";
import { events } from "./events/events";

@Component({
  selector: "app-form-laudo",
  templateUrl: "./form-laudo.component.html",
  styleUrls: ["./form-laudo.component.scss"],
})
export class FormLaudoComponent implements OnInit {
  @ViewChild(ImageEditorModalComponent, { static: false })
  imageEditor: ImageEditorModalComponent;

  stepIndex = 0;
  stepTouched = 0;
  steps = [];
  step = null;

  formLaudo = new FormGroup({});

  templates = [];

  token = null;

  laudo = {
    consultas: [],
    consultaRealizada: false,
    tokenConsulta: null,
  };

  templateElements: any = {};

  consultaResultado = null;
  exibirParecer: boolean = false;
  elements: any = {};
  template: any;
  editar: any;
  placa: any;
  resultadoValidacao: any;
  params: any;
  realizandoConsultaLaudoEmAndamento = false;
  idempotencyKeyConsultaLaudo: string | null = null;

  integraHg: boolean = false;
  formHgValido: boolean = false;

  constructor(
    private modalService: NgbModal,
    public laudoService: LaudoUnionService,
    public enderecoService: EnderecoService,
    public router: Router,
    public route: ActivatedRoute,
    public msgService: ModalMsgService,
    private zone: NgZone,
    private _hgService: HgService
  ) {
    this.params = this.route.snapshot.queryParams;
  }

  ngOnInit() {
    this.editar = this.route.snapshot.data.editar;
    this.stepIndex = parseInt(this.route.snapshot.paramMap.get("step")) || 0;
    this.route.paramMap.subscribe((r) => {
      this.token = r.get("id");
      if (this.steps.length == 0) {
        this.laudoService
          .getLaudo(this.token)
          .then((r) => this.getLaudo(r))
          .then(() => {
            if (this.editar) {
              this.formLaudo.markAllAsTouched();
            }
          });
        // this.getLaudo(configLaudo)
      } else {
        window.scrollTo(0, 0);
      }
    });
  }

  getLaudo(configLaudo) {
    this.integraHg = configLaudo?.integraHg || false;
    this.placa = configLaudo.placa;
    if (
      this.params.consulta &&
      this.params.consulta != null &&
      this.params.consulta != undefined
    ) {
      configLaudo.tokenConsulta = this.params.consulta;
    }
    this.templates = configLaudo.templates;
    this.laudo = {
      ...this.laudo,
      ...configLaudo.laudo,
      consultas: configLaudo.consultas,
      tokenConsulta: configLaudo.tokenConsulta,
      consultaRealizada: configLaudo.tokenConsulta != "",
    };
    for (const k in configLaudo.elements) {
      let options = configLaudo.options[configLaudo.elements[k].options] || [];
      let element: LaudoInput = new LaudoInput();
      element.set(configLaudo.elements[k], options);
      this.elements[k] = element;
      element.events.forEach((e) => {
        let eventName = configLaudo.events[e].event;
        if (e != "" && events[eventName] && configLaudo.events[e]) {
          events[eventName](element, configLaudo.events[e].values, this);
        }
      });
    }
    this.steps = configLaudo.steps;
    this.steps.forEach((v) => {
      v.templateComponent = v.templateComponent ? v.templateComponent : "";
      v.form = new FormGroup({});
      v.elements
        .filter((e) => this.elements[e])
        .forEach((e) => {
          v.form.addControl(e, this.elements[e].control);
        });
      this.formLaudo.addControl(v.name, v.form);
      v.form.statusChanges
        .pipe(startWith(v.form.status))
        .subscribe((r) => (v.invalid = r == "INVALID"));
    });
    this.setStepTemplate(this.stepIndex);
    this.stepTouched = this.editar ? this.steps.length : this.stepIndex;
  }

  nextStep() {
    this.stepChange(this.stepIndex + 1);
  }

  backStep() {
    this.stepChange(this.stepIndex - 1);
  }

  stepChange(i) {
    if (i != this.stepIndex) {
      if (this.step.name == "hg") {
        this.stepIndex = i;
        this.router.navigate([
          "laudo",
          this.editar ? "editar" : "adicionar",
          this.token,
          i,
        ]);
        this.setStepTemplate(i);
      } else {
        this.templateElements = {};
        this.findTemplateElements();
        this.laudoService
          .salvarFormularioLaudo(this.getValueOfElements(), this.token)
          .then((r) => {
            this.updateElements(r);
            if (this.editar) {
              this.formLaudo.markAllAsTouched();
            }
            this.stepIndex = i;
            this.router.navigate([
              "laudo",
              this.editar ? "editar" : "adicionar",
              this.token,
              i,
            ]);
            this.setStepTemplate(i);
          });
      }
    }
  }

  updateElements(obj) {
    let keys = Object.keys(obj);
    keys.forEach((k) => {
      let e = this.elements[k];
      if (e) e.control.patchValue(obj[k]);
    });
  }

  setStepTemplate(i) {
    if (i < this.steps.length) {
      this.step = this.steps[i];
      this.template = this.templates[this.step.name];
      if (!this.template) {
        console.error("template não encontrado ->", this.step.name);
      }
    }
  }

  async realizarConsulta(content) {
    //validar steps antes de realizar a consulta
    let retornoValidacaoSteps = this.validaSteps(this.steps);

    if (retornoValidacaoSteps.length > 0) {
      this.msgService.openDialog(
        "Campos obrigatórios não preenchidos",
        "Verifique o(s) seguinte(s) step(s): " +
          retornoValidacaoSteps.reduce((p, c) => p + " - " + c, " "),
        "danger",
        null
      );
      return;
    }

    let placa = this.placa || this.formLaudo.value.veiculo.placa;
    if (placa) {
      // Abrir o modal de confirmação
      let usuarioDesejaResgatar = await this.modalService.open(content, {
        ariaLabelledBy: "modal-consulta-laudo",
        size: "lg",
        centered: true,
        backdrop: "static",
        keyboard: false,
      }).result;

      // Se o usuário optar por não resgatar, efetuar a consulta
      if (usuarioDesejaResgatar != null && !usuarioDesejaResgatar)
        await this.efetuarConsulta();

      // Recarregar a página após ação de resgate ou consulta
      if (usuarioDesejaResgatar != null) window.location.reload();
    } else {
      // Exibir mensagem de erro para placa inexistente ou incorreta
      this.msgService.openDialog(
        "Consulta não realizada",
        "Placa inexistente ou incorreta.",
        "danger"
      );
    }
  }

  async efetuarConsulta() {
    if (this.realizandoConsultaLaudoEmAndamento) {
      return;
    }

    this.realizandoConsultaLaudoEmAndamento = true;
    const idempotencyKey = generateIdempotencyKey("consulta-laudo");
    this.idempotencyKeyConsultaLaudo = idempotencyKey;
    let ip = UserConfigsUtils?.getUserConfigsStorage()?.ip || "";
    try {
      const result = await this.laudoService.realizarConsultaLaudo(
        this.token,
        ip,
        idempotencyKey
      );
      this.laudo.tokenConsulta = result;
      this.laudo.consultaRealizada = true;
    } catch (e) {
      const error = e as HttpErrorResponse;
      if (error?.status == 409) {
        return this.msgService.openDialog(
          "Atencao!",
          "Foi realizada uma consulta para esse veiculo recentemente. Por favor, aguarde alguns minutos.",
          "warning"
        );
      } else {
        return this.msgService.openDialog(
          "Erro ao gerar consulta!",
          "Por favor, verifique as permissoes e tente novamente.",
          "danger"
        );
      }
    } finally {
      this.realizandoConsultaLaudoEmAndamento = false;
      this.idempotencyKeyConsultaLaudo = null;
    }
  }

  validaSteps(steps) {
    let resultadoValidacao = [];
    // Filtra os steps marcados como inválidos ...
    let stepsInvalidos = steps.filter((obj) => obj.invalid);
    // Verificações ...
    if (stepsInvalidos && stepsInvalidos.length == 0) {
      return resultadoValidacao;
    } else {
      stepsInvalidos.forEach((e) => {
        resultadoValidacao.push(e.label);
      });
      return resultadoValidacao;
    }
  }

  validaConsulta(consulta) {
    if (consulta) {
      return true;
    } else {
      return false;
    }
  }

  async showModalParecer(content) {
    if (this.integraHg) {
      await this._hgService.validarFormHg(this.token).then((isValido) => {
        this.formHgValido = isValido;
      });
    }
    if (this.integraHg && !this.formHgValido) {
      this.msgService.openDialog(
        "Campos obrigatórios não preenchidos",
        "Verifique os campos obrigatórios pertencentes à integração HG",
        "danger",
        null
      );
      return;
    }

    let retornoValidacaoSteps = this.validaSteps(this.steps);
    let retornoValidacaoConsulta = this.validaConsulta(
      this.laudo.tokenConsulta
    );

    if (retornoValidacaoSteps.length > 0) {
      this.msgService.openDialog(
        "Campos obrigatórios não preenchidos",
        "Verifique o(s) seguinte(s) step(s): " +
          retornoValidacaoSteps.reduce((p, c) => p + " - " + c, " "),
        "danger",
        null
      );
      return;
    }
    if (retornoValidacaoConsulta == false) {
      this.msgService.openDialog(
        "Consulta não realizada",
        "Por favor, realize a consulta antes de realizar o parecer técnico.",
        "danger",
        null
      );
      return;
    }

    try {
      const result = await this.laudoService.salvarFormularioLaudo(
        this.step.form.value,
        this.token
      );
      if (result) {
        this.updateElements(result);
      }

      this.aguardar(1500);
      let modalResult = await this.modalService.open(content, {
        ariaLabelledBy: "modal-parecer",
        size: "lg",
        centered: true,
      }).result;
      if (modalResult == "ok") {
        this.zone.run(() => {
          this.router.navigate(["laudo", "listar"]);
        });
      }
    } catch (error) {
      console.error("erro ao exibir modal de parecer tecnico", error);
    }
  }

  aguardar(milisegundos) {
    setTimeout(function () {
      var botoes = document.getElementById("btnM");
      botoes.click();
    }, milisegundos);
  }

  setTemplateElement(child) {
    let element = this.elements[child.element] || null;
    if (child.element) {
      this.templateElements[element.name] = element;
    }
    if (child.children && child.children.length) {
      child.children.forEach((c) => {
        this.setTemplateElement(c);
      });
    }
  }

  findTemplateElements() {
    this.templateElements = {};
    this.template.forEach((c) => {
      this.setTemplateElement(c);
    });
  }

  getValueOfElements() {
    this.findTemplateElements();
    const elementValues = {};
    for (const k in this.templateElements) {
      const e = this.templateElements[k];
      elementValues[k] = e.value;
    }
    return elementValues;
  }

  formHgValidoEmit(event: any) {
    let isDestroy = event?.isDestroy;
    let dadosHg = {
      tokenLaudo: this.token,
      formHg: event?.formHg,
      entityHgId: event?.entityHgId,
      instanceHgId: event?.instanceHgId,
      userHgId: event?.userHgId,
    };

    this._hgService
      .salvarAvaliacaoHg(dadosHg)
      .then(() => {
        if (!isDestroy)
          this.msgService.openDialog(
            "Sucesso",
            "Dados salvos com sucesso.",
            "info",
            null
          );
      })
      .catch(() => {
        if (!isDestroy)
          this.msgService.openDialog(
            "Erro ao sincronizar dados",
            "Por favor, entre em contato com nosso suporte",
            "danger",
            null
          );
      });
  }
}
